import { FC, useState } from "react";
import { registerDataType } from "../RegisterForm";
import { Button, Form, Typography, message } from "antd";
import AuthTitleAndDescription from "../../AuthTitleAndDescription";

import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import { useMutation } from "@tanstack/react-query";
import { authRegister } from "../../../../network/auth";
import { AxiosResponse } from "axios";
import { useIntl } from "react-intl";

interface PhoneNumberStepProps {
  nextStep: () => void;
  addRegisterData: (data: Partial<registerDataType>) => void;
  registerData: registerDataType;
}
const PhoneNumberStep: FC<PhoneNumberStepProps> = ({
  nextStep,
  addRegisterData,
  registerData,
}) => {
  const intl = useIntl();
  const { mutate, isError, isSuccess, data, isLoading } =
    useMutation(authRegister);

  const [form] = Form.useForm<Partial<registerDataType>>();
  const submitRegistration = (values: any) => {
    console.log(registerData);
    if (
      registerData.email &&
      registerData.firstName &&
      registerData.lastName &&
      registerData.password
    ) {
      // submit registration data to server
      const phoneNumber = parsePhoneNumber(values?.phoneNumber || "");
      console.log(phoneNumber);
      addRegisterData({
        ...registerData,
        phone: phoneNumber?.number || "",
      });
      mutate(
        {
          email: registerData.email,
          password: registerData.password,
          password_confirmation: registerData.password,
          name: `${registerData.firstName} ${registerData.lastName}`,
          phone: phoneNumber?.nationalNumber,
          phone_country_code: phoneNumber?.country,
        },
        {
          onSuccess: (res: any) => {
            if (
              res?.response?.status === 422 ||
              res?.response?.status === 500
            ) {
              message.error(res?.response?.data?.message);
            } else {
              message.success(intl.formatMessage({ id: "OTPsent" }));
              nextStep();
            }
          },
          onError: (error) => {
            message.error(intl.formatMessage({ id: "tryAgain" }));
          },
        }
      );
    } else {
      message.error("Please fill all fields");
    }

    return;
  };
  const handleClick = (values: any) => {
    submitRegistration(values);
  };
  return (
    <div className="space-y-4">
      <AuthTitleAndDescription
        titleAndDescription={{
          title: intl.formatMessage({ id: "almostDoneWithLookfindr" }),
          description: intl.formatMessage({ id: "enterPhoneTOcomplete" }),
        }}
      />
      <Form form={form} layout="vertical" onFinish={handleClick}>
        <Form.Item
          name={"phoneNumber"}
          className=""
          label={intl.formatMessage({ id: "phoneNumber" })}
          colon={false}
          required={false}
          hasFeedback
          rules={[
            {
              required: true,
              message: intl.formatMessage({ id: "phoneNumberRequired" }),
            },

            {
              validator: (_, value) => {
                if (value && !isValidPhoneNumber(value)) {
                  return Promise.reject(
                    new Error(intl.formatMessage({ id: "invalidPhoneNumber" }))
                  );
                } else {
                  return Promise.resolve();
                }
              },
            },
          ]}
        >
          <PhoneInputWithCountrySelect
            defaultCountry="SA"
            international
            onChange={() => {}}
            limitMaxLength={true}
          />
        </Form.Item>

        <Button type="primary" htmlType="submit" block loading={isLoading}>
          {intl.formatMessage({ id: "submitPhoneNumber" })}
        </Button>
      </Form>
    </div>
  );
};

export default PhoneNumberStep;
